module.exports = __webpack_public_path__ + "static/img/莱克天王星多功能洗地吸尘器.0dc2d9bd.png";